var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { syntheticEvent } from '../../components/helpers';
import { getState, escHtml, absPosition, bindDelegated, menuOutsideHandlers, trapDialogFocus, releaseDialogFocus, bindMenuOutsideClose, isDangerMenuItem, scheduleTooltipShow, cancelTooltipShow, } from './shared';
/** Floating toast notification */
export function syncNativeToast(node, parent, ctx) {
    var _a, _b, _c, _d;
    var state = getState(node);
    var message = String((_a = state.message) !== null && _a !== void 0 ? _a : 'Notification');
    var variant = String((_b = state.variant) !== null && _b !== void 0 ? _b : 'success');
    var position = String((_c = state.position) !== null && _c !== void 0 ? _c : '');
    var dismissible = state.dismissible !== false;
    var icons = {
        success: '✓',
        error: '✕',
        warning: '!',
        info: 'i',
    };
    var el = ctx.nodeElements.get(node.id);
    if (!el) {
        el = document.createElement('div');
        el.id = node.id;
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        parent.appendChild(el);
        el.addEventListener('click', function (e) {
            var _a;
            if (e.target.closest('.lightdraw-toast-dismiss')) {
                node.visible = false;
                node.emit('close', syntheticEvent('close', node));
                (_a = node.getApp()) === null || _a === void 0 ? void 0 : _a.requestRender();
            }
        });
        ctx.nodeElements.set(node.id, el);
    }
    else if (el.parentElement !== parent) {
        parent.appendChild(el);
    }
    var posClass = position ? " lightdraw-toast--".concat(position) : '';
    if (!node.visible) {
        el.style.display = 'none';
        el.className = 'lightdraw-toast';
    }
    else {
        var dismissHtml = dismissible
            ? '<button type="button" class="lightdraw-toast-dismiss" aria-label="Dismiss">×</button>'
            : '';
        el.className = "lightdraw-toast lightdraw-toast--".concat(variant).concat(posClass, " lightdraw-toast--enter");
        el.innerHTML = "<span class=\"lightdraw-toast-icon\" aria-hidden=\"true\">".concat((_d = icons[variant]) !== null && _d !== void 0 ? _d : icons.success, "</span><span class=\"lightdraw-toast-message\">").concat(escHtml(message), "</span>").concat(dismissHtml);
        el.style.display = 'flex';
    }
    var extraPos = '';
    if (position === 'top-right')
        extraPos = 'right:16px;top:16px;left:auto;';
    else if (position === 'bottom-right')
        extraPos = 'right:16px;bottom:16px;top:auto;left:auto;';
    else if (position === 'bottom-left')
        extraPos = 'left:16px;bottom:16px;top:auto;';
    var base = absPosition(node, 'auto', 44);
    el.style.cssText = base + extraPos + (node.visible ? 'display:flex;' : 'display:none;');
    ctx.applyUiClasses(node, el);
    ctx.seenIds.add(node.id);
}
/** Dropdown menu panel */
export function syncNativeMenu(node, parent, ctx) {
    var _a, _b, _c, _d;
    var state = getState(node);
    var items = (_a = state.items) !== null && _a !== void 0 ? _a : ['Item 1', 'Item 2'];
    var variants = (_b = state.itemVariants) !== null && _b !== void 0 ? _b : [];
    var triggerLabel = String((_c = state.triggerLabel) !== null && _c !== void 0 ? _c : 'Actions');
    var open = Boolean(state.open) && node.visible;
    var width = Number((_d = state.width) !== null && _d !== void 0 ? _d : 180);
    var el = ctx.nodeElements.get(node.id);
    if (!el) {
        el = document.createElement('div');
        el.id = node.id;
        el.className = 'lightdraw-menu';
        el.setAttribute('role', 'menu');
        parent.appendChild(el);
        bindDelegated(el, function (e) {
            var _a, _b, _c;
            var st = getState(node);
            var menuItems = (_a = st.items) !== null && _a !== void 0 ? _a : [];
            var isOpen = Boolean(st.open) && node.visible;
            var itemBtn = e.target.closest('.lightdraw-menu-item');
            if (itemBtn) {
                e.stopPropagation();
                var i = Number(itemBtn.getAttribute('data-index'));
                node.metadata.componentState = __assign(__assign({}, st), { open: false, selectedIndex: i });
                node.visible = false;
                node.emit('select', syntheticEvent('select', node, { index: i, item: menuItems[i] }));
                (_b = node.getApp()) === null || _b === void 0 ? void 0 : _b.requestRender();
                return;
            }
            if (!isOpen && e.target.closest('.lightdraw-menu-trigger')) {
                node.visible = true;
                node.metadata.componentState = __assign(__assign({}, st), { open: true });
                node.emit('open', syntheticEvent('open', node));
                (_c = node.getApp()) === null || _c === void 0 ? void 0 : _c.requestRender();
            }
        });
        ctx.nodeElements.set(node.id, el);
    }
    else if (el.parentElement !== parent) {
        parent.appendChild(el);
    }
    if (open) {
        var panelItems = items
            .map(function (item, i) {
            return "<button type=\"button\" class=\"lightdraw-menu-item".concat(isDangerMenuItem(item, variants, i) ? ' lightdraw-menu-item--danger' : '', "\" role=\"menuitem\" data-index=\"").concat(i, "\">").concat(escHtml(item), "</button>");
        })
            .join('');
        el.innerHTML = "<div class=\"lightdraw-menu-panel\">".concat(panelItems, "</div>");
        el.classList.add('lightdraw-menu--open');
        bindMenuOutsideClose(el, node);
    }
    else {
        var outside = menuOutsideHandlers.get(el);
        if (outside) {
            document.removeEventListener('mousedown', outside);
            menuOutsideHandlers.delete(el);
        }
        el.innerHTML = "<button type=\"button\" class=\"lightdraw-menu-trigger\">".concat(escHtml(triggerLabel), " <span aria-hidden=\"true\">\u25BE</span></button>");
        el.classList.remove('lightdraw-menu--open');
    }
    var height = open ? Math.min(items.length * 36 + 8, 248) : 36;
    el.style.cssText = absPosition(node, width, height);
    ctx.applyA11y(node, el);
    ctx.applyUiClasses(node, el);
    ctx.seenIds.add(node.id);
}
/** Modal dialog with overlay */
export function syncNativeDialog(node, parent, ctx) {
    var _a, _b, _c, _d, _e;
    var state = getState(node);
    var open = Boolean(state.open) && node.visible;
    var title = String((_a = state.title) !== null && _a !== void 0 ? _a : 'Dialog');
    var message = String((_b = state.message) !== null && _b !== void 0 ? _b : 'Are you sure you want to continue?');
    var width = Number((_c = state.width) !== null && _c !== void 0 ? _c : 320);
    var overlayW = Number((_d = state.overlayWidth) !== null && _d !== void 0 ? _d : 800);
    var overlayH = Number((_e = state.overlayHeight) !== null && _e !== void 0 ? _e : 600);
    var el = ctx.nodeElements.get(node.id);
    if (!el) {
        el = document.createElement('div');
        el.id = node.id;
        el.className = 'lightdraw-dialog-host';
        parent.appendChild(el);
        bindDelegated(el, function (e) {
            var _a;
            var st = getState(node);
            var isOpen = Boolean(st.open) && node.visible;
            var close = function () {
                var _a;
                releaseDialogFocus(el);
                node.metadata.componentState = __assign(__assign({}, getState(node)), { open: false });
                node.visible = false;
                node.emit('close', syntheticEvent('close', node));
                (_a = node.getApp()) === null || _a === void 0 ? void 0 : _a.requestRender();
            };
            if (isOpen) {
                if (e.target.classList.contains('lightdraw-dialog-overlay')) {
                    close();
                }
                else if (e.target.closest('.lightdraw-dialog-close, .lightdraw-dialog-cancel')) {
                    close();
                }
                else if (e.target.closest('.lightdraw-dialog-confirm')) {
                    node.emit('change', syntheticEvent('change', node, { value: true }));
                    close();
                }
            }
            else if (e.target.closest('.lightdraw-dialog-open')) {
                node.metadata.componentState = __assign(__assign({}, getState(node)), { open: true });
                node.visible = true;
                node.emit('open', syntheticEvent('open', node));
                (_a = node.getApp()) === null || _a === void 0 ? void 0 : _a.requestRender();
            }
        });
        ctx.nodeElements.set(node.id, el);
    }
    else if (el.parentElement !== parent) {
        parent.appendChild(el);
    }
    if (open) {
        el.className = 'lightdraw-dialog-host lightdraw-dialog-host--open';
        el.innerHTML = "<div class=\"lightdraw-dialog-overlay\" style=\"width:".concat(overlayW, "px;height:").concat(overlayH, "px;left:").concat(-node.x, "px;top:").concat(-node.y, "px\" role=\"presentation\"></div>\n      <div class=\"lightdraw-dialog-center\">\n        <div class=\"lightdraw-dialog\" role=\"dialog\" aria-modal=\"true\" aria-labelledby=\"").concat(node.id, "-title\" style=\"max-width:").concat(width, "px\">\n          <div class=\"lightdraw-dialog-header\">\n            <h2 class=\"lightdraw-dialog-title\" id=\"").concat(node.id, "-title\">").concat(escHtml(title), "</h2>\n            <button type=\"button\" class=\"lightdraw-dialog-close\" aria-label=\"Close\">\u00D7</button>\n          </div>\n          <p class=\"lightdraw-dialog-body\">").concat(escHtml(message), "</p>\n          <div class=\"lightdraw-dialog-footer\">\n            <button type=\"button\" class=\"lightdraw-btn lightdraw-btn--ghost lightdraw-dialog-cancel\">Cancel</button>\n            <button type=\"button\" class=\"lightdraw-btn lightdraw-btn--primary lightdraw-dialog-confirm\">Confirm</button>\n          </div>\n        </div>\n      </div>");
        requestAnimationFrame(function () { return trapDialogFocus(el); });
    }
    else {
        releaseDialogFocus(el);
        el.className = 'lightdraw-dialog-host';
        el.innerHTML = "<button type=\"button\" class=\"lightdraw-btn lightdraw-btn--secondary lightdraw-dialog-open\">Open dialog</button>";
    }
    el.style.cssText = absPosition(node, open ? overlayW : width, open ? overlayH : 40);
    ctx.applyA11y(node, el);
    ctx.applyUiClasses(node, el);
    ctx.seenIds.add(node.id);
}
/** Tooltip pill */
export function syncNativeTooltip(node, parent, ctx) {
    var _a, _b, _c, _d;
    var state = getState(node);
    var text = String((_a = state.text) !== null && _a !== void 0 ? _a : 'Tooltip');
    var anchor = String((_b = state.anchor) !== null && _b !== void 0 ? _b : 'Hover me');
    var placement = String((_c = state.placement) !== null && _c !== void 0 ? _c : 'bottom');
    var delay = Number((_d = state.delay) !== null && _d !== void 0 ? _d : 0);
    var el = ctx.nodeElements.get(node.id);
    if (!el) {
        el = document.createElement('div');
        el.id = node.id;
        el.className = 'lightdraw-tooltip';
        parent.appendChild(el);
        var show_1 = function () {
            var _a;
            node.visible = true;
            node.emit('open', syntheticEvent('open', node));
            (_a = node.getApp()) === null || _a === void 0 ? void 0 : _a.requestRender();
        };
        var hide = function () {
            var _a;
            cancelTooltipShow(node.id);
            node.visible = false;
            node.emit('close', syntheticEvent('close', node));
            (_a = node.getApp()) === null || _a === void 0 ? void 0 : _a.requestRender();
        };
        el.addEventListener('mouseenter', function () { return scheduleTooltipShow(node, delay, show_1); });
        el.addEventListener('mouseleave', hide);
        el.addEventListener('focusin', function () { return scheduleTooltipShow(node, delay, show_1); });
        el.addEventListener('focusout', hide);
        ctx.nodeElements.set(node.id, el);
    }
    else if (el.parentElement !== parent) {
        parent.appendChild(el);
    }
    el.className = "lightdraw-tooltip lightdraw-tooltip--".concat(placement);
    el.innerHTML = "<span class=\"lightdraw-tooltip-anchor\" tabindex=\"0\">".concat(escHtml(anchor), "</span>");
    if (node.visible) {
        el.innerHTML += "<span class=\"lightdraw-tooltip-bubble\" role=\"tooltip\">".concat(escHtml(text), "</span>");
    }
    el.style.cssText = absPosition(node, 'auto', 'auto');
    ctx.applyA11y(node, el);
    ctx.applyUiClasses(node, el);
    ctx.seenIds.add(node.id);
}
